export function initSidebar() {
  const toggleBtns = document.querySelectorAll('[data-sidebar-toggle]');
  const sidebar = document.querySelector('[data-sidebar]');
  const backdrop = document.querySelector('[data-sidebar-backdrop]');
  const collapseBtns = document.querySelectorAll('[data-sidebar-collapse]');
  const lgBreakpoint = 1024;

  function isDesktop() {
    return window.innerWidth >= lgBreakpoint;
  }

  function openMobile() {
    if (!sidebar) return;
    sidebar.classList.add('sidebar-open');
    if (backdrop) backdrop.classList.remove('hidden');
  }

  function closeMobile() {
    if (!sidebar) return;
    sidebar.classList.remove('sidebar-open');
    if (backdrop) backdrop.classList.add('hidden');
  }

  function toggleCollapse() {
    if (!sidebar) return;
    sidebar.classList.toggle('sidebar-collapsed');
    document.body.classList.toggle('sidebar-collapsed');
  }

  function handleToggle() {
    if (isDesktop()) {
      toggleCollapse();
    } else {
      if (sidebar && sidebar.classList.contains('sidebar-open')) {
        closeMobile();
      } else {
        openMobile();
      }
    }
  }

  toggleBtns.forEach(btn => btn.addEventListener('click', handleToggle));
  collapseBtns.forEach(btn => btn.addEventListener('click', toggleCollapse));

  if (backdrop) backdrop.addEventListener('click', closeMobile);

  window.addEventListener('resize', () => {
    if (isDesktop()) {
      closeMobile();
    }
  });
}
